import {
  ArrowDownLeft,
  ArrowLeftRight,
  Calculator,
  CheckCircle2,
  Plane,
  PlusCircle,
  RefreshCw,
  Sparkles,
} from "lucide-react";
import type { DashboardData, Trip, TripStatus } from "../../types";
import { getDefaultTripAccount, getDefaultTripToAccount } from "../../lib/trips";

export interface TripActionsBarProps {
  trip: Trip;
  data: DashboardData;
  busy: boolean;
  showConverter: boolean;
  onAddTransaction: (prefill: {
    tripId?: string;
    tripDestination?: string;
    type?: "Expense" | "Income" | "Transfer";
    accountId?: string;
    toAccountId?: string;
  }) => void;
  onToggleConverter: () => void;
  onShowRecap: () => void;
  onUpdateStatus: (status: TripStatus) => void;
}

export default function TripActionsBar({
  trip,
  data,
  busy,
  showConverter,
  onAddTransaction,
  onToggleConverter,
  onShowRecap,
  onUpdateStatus,
}: TripActionsBarProps) {
  return (
    <>
      <div className="account-quick-actions trip-actions-bar">
        <button
          type="button"
          onClick={() => {
            const defaultAcc = getDefaultTripAccount(trip, data.accounts, trip.destinations[0], data.trips, "Expense");
            onAddTransaction({
              tripId: trip.id,
              tripDestination: trip.destinations[0],
              type: "Expense",
              accountId: defaultAcc?.id,
            });
          }}
        >
          <PlusCircle size={18} />
          <span>Add expense</span>
        </button>

        <button
          type="button"
          onClick={() => {
            const defaultAcc = getDefaultTripAccount(trip, data.accounts, trip.destinations[0], data.trips, "Income");
            onAddTransaction({
              tripId: trip.id,
              tripDestination: trip.destinations[0],
              type: "Income",
              accountId: defaultAcc?.id,
            });
          }}
        >
          <ArrowDownLeft size={18} />
          <span>Add income</span>
        </button>

        <button
          type="button"
          onClick={() => {
            const defaultFrom = getDefaultTripAccount(trip, data.accounts, trip.destinations[0], data.trips, "Transfer");
            const defaultTo = getDefaultTripToAccount(trip, data.accounts, defaultFrom?.id, trip.destinations[0], data.trips);
            onAddTransaction({
              tripId: trip.id,
              tripDestination: trip.destinations[0],
              type: "Transfer",
              accountId: defaultFrom?.id,
              toAccountId: defaultTo?.id,
            });
          }}
        >
          <ArrowLeftRight size={18} />
          <span>Transfer / FX</span>
        </button>

        <button
          type="button"
          onClick={onToggleConverter}
          className={showConverter ? "active" : ""}
        >
          <Calculator size={18} />
          <span>Converter</span>
        </button>

        {trip.status === "active" ? (
          <button
            type="button"
            disabled={busy}
            onClick={() => void onUpdateStatus("completed")}
          >
            <CheckCircle2 size={18} />
            <span>Finish trip</span>
          </button>
        ) : trip.status === "completed" ? (
          <button
            type="button"
            onClick={onShowRecap}
          >
            <Sparkles size={18} />
            <span>Trip recap</span>
          </button>
        ) : (
          <button
            type="button"
            disabled={busy}
            onClick={() => void onUpdateStatus("active")}
          >
            <Plane size={18} />
            <span>Start trip</span>
          </button>
        )}
      </div>

      {trip.status === "completed" && (
        <div className="trip-reactivate-row">
          <button
            type="button"
            className="text-button subtle"
            disabled={busy}
            onClick={() => void onUpdateStatus("active")}
          >
            <RefreshCw size={13} /> Reopen trip as active
          </button>
        </div>
      )}
    </>
  );
}
